export const STUDENT_TEMPLATE_COLUMNS = [
  'Student ID',
  'Full Name',
  'Date of Birth (dd/mm/yyyy)',
  'Gender (Male, Female)',
  'NIC Number',
  'Telephone',
  'Email',
  'Address',
  'Registration Number',
  'University ID',
  'University Register Date (dd/mm/yyyy)',
  'Batch ID (From kaaryaalaya)',
  'Name Verification'
];

export const STUDENT_TEMPLATE_FIELD_MAP = {
  'Student ID': 'studentId',
  'Full Name': 'fullName',
  'Date of Birth (dd/mm/yyyy)': 'dob',
  'Gender (Male, Female)': 'gender',
  'NIC Number': 'nicNumber',
  'Telephone': 'telephone',
  'Email': 'email',
  'Address': 'address',
  'Registration Number': 'registrationNumber',
  'University ID': 'universityID',
  'University Register Date (dd/mm/yyyy)': 'universityRegisterDate',
  'Batch ID (From kaaryaalaya)': 'batchId',
  'Name Verification': 'verifiedName'
};

export const STUDENT_TEMPLATE_MANDATORY_COLUMNS = [
  'Student ID',
  'Full Name',
  'Registration Number',
  'Batch ID (From kaaryaalaya)'
];
